import React, {Component} from 'react';
import Record from '../EditChapterPart/Record';
import api from '../../utils/api';
import {NotificationManager} from 'react-notifications';
import successAudio from '../../assets/audio/appointed.mp3';
import errorAudio from '../../assets/audio/unsure.mp3';

/* global $ */

class VideoQuestion extends Component {
    constructor(props){
        super(props);
        
        this.state = {
            attempts: 1,
            currentModalQuestionIndex: 0,
            currentModalOptionIndex: 0,
            textTracksMode: 'showing',
            audioAnswer: '',
            audio: null,
            showReadOnlyQuestion: false,
            frameQuestions: [],
            question: null,
            showSeek: false,
            throwback: -1,
            throwForward: -1,
            throwBackId: null,
            throForwardId: null
        }
    }
    
    updateThrowback = () => {
        if(this.state.throwback > 1){
            this.setState({throwback: this.state.throwback - 1});
        }else{
            let self = this;
            this.setState({throwback: -1}, () => {
                clearInterval(self.state.throwBackId);
                self.props.setThrowback();
                $('#MCQChallange').modal('hide');    
            })
        }
    }
    
    updateThrowForward = () => {
        if(this.state.throwForward > 1){
            this.setState({throwForward: this.state.throwForward - 1});
        }else{
            let self = this;
            this.setState({throwForward: -1}, () => {
                clearInterval(self.state.throwForwardId);
                self.props.setThrowforward();
                $('#MCQChallange').modal('hide');    
            })
            
        }
    }
    
    throwBack = () => {
        let self = this;
        this.setState({throwback: 3, currentModalOptionIndex: 0}, () => {
            let timer = setInterval(self.updateThrowback, 1000);
            self.setState({throwBackId: timer});
        });
    }
    
    throwForward = () => {
        let self = this;
        this.setState({throwForward: 3, currentModalOptionIndex: 0}, () => {
            let timer = setInterval(self.updateThrowForward, 1000);
            self.setState({throwForwardId: timer});
        });
    }
    
    
    componentDidUpdate(props){
        if(JSON.stringify(props) !== JSON.stringify(this.props)){
            // console.log(" Updating VQ");
             
            if(this.props.frameQuestions.length > 0 && this.state.question === null){
               
                this.setState({question: this.props.frameQuestions[0], attempts: 1}, () => {
                    // console.log("Showing Question");
                    $('#MCQChallange').modal('show');
                })
            }
        }
    }

    renderOption = (option, index) => {

        if(this.state.question["option" + option.letter]){
            return (

                <li key={index}>
                    <label>
                        <div
                            className={`iradio_square video-modal-radio-wrapper ${this.state.currentModalOptionIndex === option.number && 'checked'}`}
                        >
                            <input
                                type="radio"
                                name="radio"
                                value="60"
                                className='video-modal-radio'
                                onClick={() => this.checkModalAnswerOption(option.number)}
                            />
                            <ins className="iCheck-helper video-modal-radio-icon"/>
                        </div>
                        <div className="video-answer" dangerouslySetInnerHTML={{__html: this.state.question["option" + option.letter]}}></div>
                    </label>
                </li>
            )
        }else{
            return null;
        }
    }
    
    
    recordingDone = (data) => {
        this.setState({audio: data});

    }
    
    checkModalAnswerOption = (index) => {
        this.setState({
            currentModalOptionIndex: index
        })
    };

    playAnswerSound = () => {
        this.audioSource.play();
    };
    
    hideModal = () => {
        $('#MCQChallange').modal('hide');
        let self = this;
        setTimeout(function(){
            self.setState({question: null});
        }, 500);
    }
    
    
    handleFakeSubmitAudioAnswerModal = () => {
        let answers = this.state.question.answer.split(',');

        answers = answers.map(a => {
            return a.toLowerCase().trim();
        });

        if (answers.indexOf(this.state.audioAnswer.toLowerCase().trim()) > -1) {
            this.setState({
                attempts: 1,
                count: this.state.count + 1,
                show: false,
                currentModalOptionIndex: 0,
                audioAnswer: '',
                showReadOnlyQuestion: false
            });
            this.play();
            var audio = new Audio(successAudio);
            audio.play();
            NotificationManager.success("Great Job!");

            this.throwForward();

        } else {
            let seek = false;
            if(2 % this.state.attempts){
                this.throwBack();
            }
            var audio = new Audio(errorAudio);
            audio.play();
            this.setState({attempts: this.state.attempts + 1, showSeek: seek, currentModalOptionIndex: 0});
            NotificationManager.error("Try again.  If we notice you're having a bit of trouble with this question, we'll try and help you out.", "That's not quite right");
            let correct = false;


        }
    }

    handleSubmitAudioAnswerModal = () => {
        let correct = false;
        let complete = false;

        let answers = this.state.question.answer.split(',');

        answers = answers.map(a => {
            return a.toLowerCase().trim();
        });

        if (answers.indexOf(this.state.audioAnswer.toLowerCase().trim()) > -1) {
            correct = true;
            complete = true;

            this.throwForward();
            NotificationManager.success("Great Job!");
            var audio = new Audio(successAudio);
            audio.play();

        } else {
            let seek = false;
            var audio = new Audio(errorAudio);
            audio.play();
            if(this.state.attempts % 2){
                NotificationManager.error("We're sending you back to the relevant part of the lecture for this question.", "That's not quite right");

                this.throwBack();
                


            }else{
                NotificationManager.error("If we notice you're having a bit of trouble, we'll help you out.", "That's not quite right");
                this.setState({showSeek: false, attempts: this.state.attempts + 1, currentModalOptionIndex: 0});
            }
            correct = false;

        }

        if(!this.props.embedded){
            let existing = this.props.videoQuestions.filter(v => v.videoQuestionId == this.state.question.id && !v.complete)
    
            let question;
            let answeredQuestions = this.props.videoQuestions.filter(v => v.complete && v.videoQuestionId === this.state.question.id);
    
            if(existing.length > 0){
                existing[0].attempts += 1;
                existing[0].correct = correct;
                existing[0].complete = complete;
    
                question = existing[0];
            }else if(answeredQuestions.length === 0){
                question = {
                    attempts: this.state.attempts,
                    correct: correct,
                    complete: complete,
                    text: this.state.question.question,
                    profileId: this.props.user.user.Profile.id,
                    videoQuestionId: this.state.question.id,
                    chapterVideoId: this.state.question.chapterVideoId,
                    userLectureId: this.props.userLecture.id
                }
    
            }
    
            // Add or update uservideoquestion based on this question
            this.props.updateVideoQuestion(question, this.props.user.id);
            //this.updateCourseUserCurrentTime();

            if(this.props.qi === this.props.totalQuestions){
                this.props.onFinish();    
            }
        }




    }

    handleFakeSubmitAnswerModal = () => {
        let correct = false;

        if (this.state.currentModalOptionIndex == this.state.question.correctOption) {
            this.throwForward();
            NotificationManager.success("Great Job!");
            var audio = new Audio(successAudio);
            audio.play();
            
        } else {
            let seek = false;
            if(2 % this.state.attempts){
                this.throwBack();
                
            }
            var audio = new Audio(errorAudio);
            audio.play();
            this.setState({attempts: this.state.attempts + 1, showSeek: seek, currentModalOptionIndex: 0});
            NotificationManager.error("Try again.  If we notice you're having a bit of trouble with this question, we'll try and help you out.", "That's not quite right");
            correct = false;


        }


    }


    handleSubmitAnswerModal = () => {
        let correct = false;
        let complete = false;

        if (this.state.currentModalOptionIndex == this.state.question.correctOption) {

            correct = true;
            complete = true;

            this.throwForward();
            NotificationManager.success("Great Job!");
            var audio = new Audio(successAudio);
            audio.play();

        } else {
            let seek = false;
            var audio = new Audio(errorAudio);
            audio.play();
            if(this.state.attempts % 2){
                NotificationManager.error("We're sending you back to the relevant part of the lecture for this question.", "That's not quite right");

                this.throwBack();
                


            }else{
                NotificationManager.error("If we notice you're having a bit of trouble, we'll help you out.", "That's not quite right");
                this.setState({showSeek: false, attempts: this.state.attempts + 1, currentModalOptionIndex: 0});
            }
            correct = false;



        }
        
        if(!this.props.embedded){
            let existing = this.props.videoQuestions.filter(v => v.videoQuestionId == this.state.question.id && !v.complete)
    
            let question;
            let answeredQuestions = this.props.videoQuestions.filter(v => v.complete && v.videoQuestionId === this.state.question.id);
    
            if(existing.length > 0){
                existing[0].attempts += 1;
                existing[0].correct = correct;
                existing[0].complete = complete;
    
                question = existing[0];
            }else if(answeredQuestions.length === 0){
                question = {
                    attempts: this.state.attempts,
                    correct: correct,
                    complete: complete,
                    text: this.state.question.question,
                    profileId: this.props.user.user.Profile.id,
                    videoQuestionId: this.state.question.id,
                    chapterVideoId: this.state.question.chapterVideoId,
                    userLectureId: this.props.userLecture.id
                }
    
            }
    
            // Add or update uservideoquestion based on this question
            this.props.updateVideoQuestion(question, this.props.user.id);
            //this.updateCourseUserCurrentTime();

            if(this.props.qi === this.props.totalQuestions){
                this.props.onFinish();    
            }
        }
        


    }
    
    render(){
        if(this.state.question){
            const options = [
                {letter: 'A', number: 1},
                {letter: 'B', number: 2},
                {letter: 'C', number: 3},
                {letter: 'D', number: 4},
            ]
        
        return (
                    <div
                        className="modal fade"
                        id="MCQChallange"
                        tabIndex="-1"
                        role="dialog"
                        aria-labelledby="myModalLabel"
                    >
                        <div
                            // className="modal-dialog"
                            className={`modal-dialog ${this.props.isFullscreen && 'fullscreen_modal'}`}
                            role="document"
                        >
                            <div className="modal-content">
                                {/*<div className="timer">*/}
                                {/*<h1>36:06</h1>*/}
                                {/*</div>*/}
                                <div className="modal-header">
                                    <button
                                        type="button"
                                        className="close"
                                        data-dismiss="modal"
                                        aria-label="Close"
                                        onClick={(e) => {
                                            this.throwBack();
                                        }}
                                    >
                                        <span aria-hidden="true">×</span>
                                    </button>
                                    <h4
                                        className="modal-title"
                                        id="myModalLabel">
                                        Challenge Question
                                    </h4>
                                </div>
                                
                                {this.state.throwForward > -1 ?
                                    this.state.throwForward > 3 ?
                                        <div className="loader-center text-center">
                                            <div className="circle-loader load-complete">
                                              <div className="checkmark draw"></div>
                                            </div>
                                        </div>
                                    :
                                     <div className="result-animation">
                                                <span className="result-text">Resuming in</span>
                                                <div className="text-success">
                                                    {this.state.throwForward}
                                                    <br /><br />
                                                </div>
                                            </div>
                                :
                            
                                this.state.question.tag == "Text" ?
                                    <div>
                                        <div className="modal-body audio-answer">
                                        {
                                            this.state.throwback > -1 ?
                                            
                                            <div className="result-animation">
                                                <span className="result-text">We're sending you back to the answer in</span>
                                                <div className="text-danger">
                                                    {this.state.throwback}
                                                </div>
                                            </div>
                                        :
                                            <div className="final_quiz_list">
                                                <div
                                                    className="question sp-20 active-question"
                                                    id="FinalQuizQuestion3"
                                                >
                                                    <p className="font-18">
                                                        {this.state.question.question}
                                                    </p>
                                        <audio autoPlay controls>
                                            <source src={api.makeFileURL(this.state.question.audioUrl, this.props.user.id)} type="audio/webm" />
                                        </audio>
                                        <br /><br />
                                        <Record user={this.props.user} recordingFinished={(data) => {
                                            this.recordingDone(data);
                                            this.setState({audioAnswer: data.text})
                                        }} />
                                        <input
                                            className="form-control"
                                            value={this.state.audioAnswer}
                                            onChange={(e) => this.setState({audioAnswer: e.target.value})} />

                                    </div>
                                        <div className="modal-footer">
                                            <div className="row">
                                                {this.state.showReadOnlyQuestion ?
                                                    <div className="col-xs-6">


                                                        <div className="final-mcqs-controls">

                                                            <button
                                                                className="btn btn-danger"
                                                                onClick={(e) => this.handleFakeSubmitAudioAnswerModal()}
                                                            >
                                                                Submit Answer
                                                            </button>
                                                        </div>
                                                    </div>

                                                    :

                                                    <div className="col-xs-6">

                                                        {this.state.showSeek == false ?
                                                            <div className="final-mcqs-controls">
                                                                <button
                                                                    className="btn btn-default"
                                                                    onClick={(e) => {
                                                                        this.throwBack();
                                                                    }}
                                                                >
                                                                    I don't know
                                                                </button>
                                                                <button
                                                                    className="btn btn-danger"
                                                                    onClick={(e) => this.handleSubmitAudioAnswerModal()}
                                                                >
                                                                    Submit Answer
                                                                </button>
                                                            </div>

                                                            :

                                                            <div className="final-mcqs-controls">

                                                                <button
                                                                    className="btn btn-danger"
                                                                    onClick={(e) => {
                                                                        this.throwBack();
                                                                    }}
                                                                >
                                                                    Seek to Answer
                                                                </button>
                                                            </div>
                                                        }
                                                    </div>
                                                }

                                                <div className="col-xs-6">
                                                    <div className="paginationFinalQuiz text-right">
                                                        {this.props.qi}/{this.props.totalQuestions}
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                            </div>
                                            }
                                        </div>
                                    </div>


                                    :
                                    <div>
                                    <div className="modal-body">
                                        {
                                            this.state.throwback > -1 ?
                                            
                                            <div className="result-animation">
                                                <span className="result-text">We're sending you back to the answer in</span>
                                                <div className="text-danger">
                                                    {this.state.throwback}
                                                </div>
                                            </div>
                                        :
                                        <div className="final_quiz_list">
                                            <div
                                                className="question sp-20 active-question"
                                                id="FinalQuizQuestion3"
                                            >
                                                <p className="font-18" dangerouslySetInnerHTML={{__html: this.state.question.question}}>
                                                </p>
                                                <ul className="list-unstyled mcqList">
                                                    {options.map((option, index) => {
                                                        return this.renderOption(option, index);
                                                    })}
                                                    
                                                </ul>

                                            </div>
                                        </div>
                                        
                                        }
                                    </div>
                                        <div className="modal-footer">
                                            <div className="row">
                                                {this.state.showReadOnlyQuestion ?
                                                    <div className="col-xs-6">


                                                        <div className="final-mcqs-controls">

                                                            <button
                                                                className="btn btn-danger"
                                                                onClick={(e) => this.handleFakeSubmitAnswerModal()}
                                                            >
                                                                Submit Answer
                                                            </button>
                                                        </div>
                                                    </div>

                                                    :

                                                    <div className="col-xs-6">

                                                        {this.state.showSeek == false ?
                                                            <div className="final-mcqs-controls">
                                                                <button
                                                                    className="btn btn-default"
                                                                    onClick={(e) => {
                                                                        this.throwBack();
                                                                    }}
                                                                >
                                                                    I don't know
                                                                </button> &nbsp;
                                                                <button
                                                                    className="btn btn-danger"
                                                                    onClick={(e) => this.handleSubmitAnswerModal()}
                                                                >
                                                                    Submit Answer
                                                                </button>
                                                            </div>

                                                            :

                                                            <div className="final-mcqs-controls">

                                                                <button
                                                                    className="btn btn-danger"
                                                                    onClick={(e) => this.throwBack()}
                                                                >
                                                                    Seek to Answer
                                                                </button>
                                                            </div>
                                                        }
                                                    </div>
                                                }

                                                <div className="col-xs-6">
                                                    <div className="paginationFinalQuiz text-right">
                                                        {this.props.qi}/{this.props.totalQuestions}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }


                            </div>
                        </div>
                    </div>
                )
        }else{
            return (
                <div></div>    
            )
        }
        
        
    }
}

export default VideoQuestion;


// WEBPACK FOOTER //
// ./src/components/Video/VideoQuestion.js